import React, { useEffect, useRef } from 'react';
interface MeasurementInputProps {
    icon: (props: any) => JSX.Element;
    label: string;
    unit: string;
    color: MeasurementColor;
    onChangeText?: (text: string) => any;
    readOnly?: boolean;
    inputProps?: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

}

const MEASUREMENT_COLORS = [{
    name: "red",
    color: "#DC3B3B"
},
{
    name: "purple",
    color: "#3747E6"
},
{
    name: "orange",
    color: "#EC9736"
},
{
    name: "blue",
    color: "#0592E4"
},
{
    name: "cyan",
    color: "#00C1B3"
}
] as const;

type MeasurementColor = typeof MEASUREMENT_COLORS[number]['name']

const MeasurementInput: React.FC<MeasurementInputProps> = ({ icon, label, unit, color, onChangeText, readOnly, inputProps }) => {

    const inputRef = useRef<HTMLInputElement>(null);
    const divRef = useRef<HTMLDivElement>(null);

    const Icon = icon;
    const selectedColor = (MEASUREMENT_COLORS.find((d) => d.name === color) || MEASUREMENT_COLORS[0]).color;

    const onFocus = () => {
        if (divRef.current) {
            divRef.current.style.borderColor = selectedColor
        }
    }

    const onBlur = () => {
        if (divRef.current) {
            divRef.current.style.borderColor = "#00000000"
        }
    }

    return (
        <div style={{ backgroundColor: `${selectedColor}1A` }} className={`flex w-full items-start flex-row font-Poppins rounded-lg gap-1 p-2 justify-start border border-[#00000000]`}
            ref={divRef}
            onClick={() => inputRef.current?.focus()}
        >
            <div onClick={() => inputRef.current?.focus()} onTouchStart={() => inputRef.current?.focus()} className='rounded-[8px] p-1' style={{ backgroundColor: `${selectedColor}33` }}>
                <Icon className={`h-6 w-6`} color={selectedColor} />
            </div>
            <div className={`flex flex-col items-start text-dark-primary font-normal text-xs`}>
                <div className='w-full whitespace-nowrap '>
                    {label}
                </div>
                <div className='text-dark-primary'>
                    <input
                        readOnly={readOnly}
                        ref={inputRef}
                        className='bg-[#00000000] w-8 focus:outline-none text-[#000] text-xs font-semibold placeholder:font-normal'
                        placeholder={unit}
                        onChange={(e) => onChangeText && onChangeText(e.target.value)}
                        maxLength={3}
                        max={999}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        {...inputProps}
                    />
                    <label>{unit}</label>
                </div>
            </div>
        </div>
    );
}

export default MeasurementInput;